import React from "react";

const Header = () => (
  <section className="hero-section">
    <h1>Gerador de Link: Influencer</h1>
  </section>
);

export default Header;
